export const WARRANTY_BASE = "/warranty";

export const warrantyPaths = {
  base: () => WARRANTY_BASE,
  claims: (passportId?: string) =>
    passportId
      ? `${WARRANTY_BASE}/claims?passportId=${encodeURIComponent(passportId)}`
      : `${WARRANTY_BASE}/claims`,
  claimNew: (passportId?: string) =>
    passportId
      ? `${WARRANTY_BASE}/claims/new?passportId=${encodeURIComponent(passportId)}`
      : `${WARRANTY_BASE}/claims/new`,
  claimDetail: (id: string) => `${WARRANTY_BASE}/claims/${id}`,
  thresholds: () => `${WARRANTY_BASE}/thresholds`,
  exposure: () => `${WARRANTY_BASE}/exposure`,
};
